module.exports = __webpack_public_path__ + "media/images/flags/cr-fba3ebb5e0253bfca765806647064d75.svg";